import React from 'react';
import { Table, Typography } from 'antd';
import { calendar, campaigns } from '../../mockData';
import './Calendar.css';

function SchedulingCalendar() {
  const { Title } = Typography;

  const columns = [
    { title: 'Date', dataIndex: 'date', key: 'date' },
    { title: 'Title', dataIndex: 'title', key: 'title' },
    { title: 'Campaign', key: 'campaign', render: (_, r) => campaigns.find((c) => c.id === r.campaignId)?.name || '—' },
  ];

  return (
    <div className="agency-budgets-calendar">
      <Title level={3}>Multi-Client Calendar</Title>
      <Table rowKey="id" columns={columns} dataSource={calendar} pagination={{ pageSize: 5 }} />
    </div>
  );
}

export default SchedulingCalendar;
